// extracted by mini-css-extract-plugin
module.exports = {"alert":"style_alert__28bFz","icon":"style_icon__d2ZXp","text":"style_text__3toln"};